var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 80,
    viewBox: "0 0 442 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_8480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.30583 0H0V36.6651H3.30583V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6115 0H13.2866V36.6651H16.6115V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6709 14.9023V36.6651H96.0021V20.5558L92.6709 14.9023Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96204 0H6.63721V36.6651H9.96204V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3081 25.9744V36.6652H102.633V31.5707L99.3081 25.9744Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2487 0H19.9238V36.6651H23.2487V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5226 0H74.1978V36.6651H77.5226V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.236 0H60.9111V36.6651H64.236V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20208 54.7435C10.9057 58.4977 13.1855 61.7309 16.0481 64.4306C18.9106 67.1494 22.3241 69.3092 26.2949 70.9163C30.2593 72.5234 34.4138 73.3238 38.7519 73.3238C43.09 73.3238 47.2572 72.5234 51.228 70.9163C55.1988 69.3092 58.6122 67.1494 61.4748 64.4306C64.3373 61.7246 66.6172 58.4977 68.3208 54.7435C70.037 50.9893 70.892 47.0636 70.892 42.9665V36.665H67.5671V42.9665C67.5671 47.8323 66.2752 52.3487 63.6913 56.5094C61.1075 60.6574 57.6053 63.9415 53.1849 66.3681C48.7707 68.7819 43.964 69.9888 38.7583 69.9888C33.5525 69.9888 28.7584 68.7819 24.3316 66.3681C19.9175 63.9415 16.4217 60.6511 13.8378 56.5094C11.254 52.3487 9.96204 47.8386 9.96204 42.9665V36.665H6.63721V42.9665C6.63721 47.0636 7.49216 50.9893 9.20841 54.7435H9.20208Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3132 52.1454C16.6748 55.0674 18.4924 57.5893 20.7596 59.7109C23.0395 61.8453 25.75 63.5413 28.8912 64.7927C32.026 66.0441 35.3192 66.673 38.758 66.673C42.1968 66.673 45.509 66.0505 48.6439 64.7927C51.785 63.5413 54.4892 61.8453 56.7754 59.7109C59.0427 57.5893 60.8602 55.0674 62.2155 52.1454C63.5644 49.2361 64.2421 46.1807 64.2421 42.9665V36.665H60.9172V42.9665C60.9172 46.6317 59.9293 50.0301 57.9471 53.1681C55.9585 56.2998 53.267 58.7835 49.8725 60.6002C46.4716 62.4233 42.7668 63.3317 38.758 63.3317C34.7492 63.3317 31.0634 62.4233 27.6626 60.6002C24.2617 58.7835 21.5702 56.2998 19.588 53.1681C17.6121 50.0301 16.6178 46.6317 16.6178 42.9665V36.665H13.293V42.9665C13.293 46.1743 13.9706 49.2361 15.3195 52.1454H15.3132Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.34 36.665H86.0151V76.665H89.34V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1976 42.9665C74.1976 47.5083 73.2603 51.8532 71.3794 56.0139C69.5112 60.1874 66.9906 63.7764 63.8178 66.7873C60.6513 69.7983 56.8768 72.1931 52.4943 73.9717C48.1056 75.763 43.5268 76.665 38.7517 76.665C33.9766 76.665 29.4105 75.7694 25.0281 73.9717C20.6393 72.1867 16.8648 69.7919 13.7046 66.7873C10.5255 63.7764 8.00493 60.1874 6.12402 56.0139C4.24945 51.8532 3.30583 47.5083 3.30583 42.9665V36.665H0V42.9665C0 49.6299 1.74158 55.8043 5.2184 61.4959C8.68256 67.1939 13.3943 71.7039 19.36 75.0135C25.3067 78.3357 31.7727 80 38.758 80C45.7434 80 52.222 78.3357 58.1751 75.0135C64.1218 71.7039 68.8399 67.1939 72.3167 61.4959C75.7935 55.8043 77.5351 49.6299 77.5351 42.9665V36.665H74.2103V42.9665H74.1976Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8917 0H67.5669V36.6651H70.8917V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4652 54.9912C29.1574 58.3261 33.5905 59.9968 38.7582 59.9968C43.926 59.9968 48.3717 58.3261 52.0702 54.9912C55.7624 51.669 57.6116 47.6607 57.6116 42.9665V36.665H54.2868V42.9665C54.2868 46.7333 52.7668 49.9603 49.727 52.6409C46.6998 55.3215 43.0457 56.6619 38.7646 56.6619C34.4834 56.6619 30.842 55.3215 27.8148 52.6409C24.7749 49.9603 23.255 46.7397 23.255 42.9665V36.665H19.9302V42.9665C19.9302 47.6544 21.7794 51.6627 25.4716 54.9912H25.4652Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5988 0H54.2739V36.6651H57.5988V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.757 36.665H270.451V76.665H273.757V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.834 36.665H250.509V76.665H253.834V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.859 36.665H282.535V76.665H285.859V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.497 36.665H289.172V76.665H292.497V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9957 36.665H92.6709V76.665H95.9957V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.127 36.665H263.802V76.665H267.127V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.146 36.665H295.821V76.665H299.146V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.477 76.6651H305.789V42.4012L302.477 36.9001V76.6651Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.513 76.665H333.351L308.905 36.665H305.004L329.513 76.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.964 76.6651H109.289V42.4012L105.964 36.9001V76.6651Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.073 76.665H349.044L324.548 36.665H320.609L345.073 76.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.322 76.665H341.198L316.682 36.665H312.807L337.322 76.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.471 36.665H257.146V76.665H260.471V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.802 76.665H144.678L120.169 36.665H116.293L140.802 76.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.971 36.665H175.646V76.665H178.971V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.554 76.665H152.524L128.035 36.665H124.089L148.554 76.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.012 76.665H136.831L112.392 36.665H108.497L133.012 76.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.614 38.6088C236.962 40.2159 237.982 42.0581 238.679 44.1416C239.369 46.2315 239.717 48.0101 239.717 49.4902C239.717 52.8251 239.065 55.9758 237.748 58.936C236.437 61.8961 234.695 64.4243 232.51 66.5205C230.332 68.6168 227.761 70.281 224.797 71.507C221.846 72.7203 218.761 73.3238 215.532 73.3238H194.113V76.6587H215.532C219.249 76.6587 222.77 76.0235 226.101 74.7657C229.413 73.5016 232.327 71.723 234.835 69.4362C237.342 67.143 239.331 64.2845 240.807 60.848C242.295 57.4051 243.036 53.6191 243.036 49.4902C243.036 45.8123 241.757 42.2042 239.198 38.666C239.679 38.0181 240.104 37.3511 240.49 36.665H236.893C236.5 37.3193 236.082 37.9736 235.607 38.6088H235.614Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.633 36.665H99.3081V76.665H102.633V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.538 37.224H194.12V40.559H215.538C216.184 40.559 216.652 40.5399 216.956 40.5018C220.066 40.7813 222.428 41.7849 224.024 43.5191C225.626 45.2533 226.424 47.2415 226.424 49.4902C226.424 52.8251 225.367 55.4105 223.245 57.2463C221.143 59.0757 218.571 59.9968 215.532 59.9968H194.113V63.3317H215.532C219.464 63.3317 222.814 62.074 225.588 59.5585C228.35 57.043 229.73 53.689 229.73 49.4902C229.73 44.1797 227.317 40.6606 222.492 38.9264C223.688 38.3103 224.746 37.5544 225.683 36.6587H219.325C218.153 37.0271 216.899 37.2177 215.538 37.2177V37.224Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.938 38.5644C229.54 39.7014 230.794 41.3594 231.7 43.5318C232.605 45.7043 233.061 47.6925 233.061 49.4839C233.061 54.4767 231.339 58.593 227.9 61.8262C224.448 65.0532 220.326 66.6603 215.538 66.6603H194.12V69.9762H215.538C219.217 69.9762 222.65 69.1059 225.842 67.359C229.027 65.6249 231.579 63.1729 233.498 59.9968C235.424 56.8397 236.392 53.327 236.392 49.4712C236.392 45.6153 234.866 41.7977 231.82 38.3992C232.32 37.8275 232.764 37.2431 233.188 36.646H229.705C229.179 37.3066 228.597 37.9419 227.951 38.5517L227.938 38.5644Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.614 36.665H182.302V76.665H185.614V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.264 36.665H188.939V76.665H192.264V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.315 36.665H169.009V76.665H172.315V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.102 61.7627V36.665H346.771V56.1092L350.102 61.7627Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.465 0H340.14V36.6651H343.465V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.426 71.2402L332.274 36.6587H328.379L352.825 76.6587H356.758V36.665H353.433V71.2466L353.426 71.2402Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0151 0V36.6651H89.34V5.42481L108.491 36.6651H112.386L89.9859 0H86.0151Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.809 36.665H334.934L336.809 39.7649V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.095 0H346.771V36.6651H350.095V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.19 0L320.609 36.6651H324.548L302.097 0H298.19Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.343 0L312.806 36.6651H316.682L294.219 0H290.343Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.855 0H305.973L328.379 36.6651H332.274L309.855 0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.809 0H333.484V34.2639L334.934 36.6651H336.809V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.118 63.3317C411.709 63.3317 415.066 62.2201 418.175 59.9968C421.291 57.7735 423.761 54.7308 425.585 50.875C427.415 47.0192 428.327 42.8394 428.327 38.342C428.327 37.7767 428.314 37.2177 428.283 36.665H424.85C424.882 37.2177 424.901 37.7767 424.901 38.342C424.901 44.2941 423.248 49.3886 419.949 53.6255C416.649 57.8751 412.697 59.9968 408.112 59.9968H382.115V36.665H378.79V63.3381H408.112L408.118 63.3317Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.835 3.33493H408.118C412.152 3.33493 416.041 4.256 419.784 6.1045C423.539 7.9657 426.788 10.4558 429.537 13.5938C432.272 16.7127 434.457 20.4415 436.097 24.761C437.554 28.5723 438.365 32.5361 438.536 36.6587H441.962C441.728 30.3827 440.195 24.5323 437.345 19.1075C434.255 13.219 430.113 8.55646 424.907 5.13261C419.714 1.70875 414.122 -0.00634766 408.118 -0.00634766H365.503V36.6651H368.828V3.33493H368.835Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.491 9.99213H408.118C412.298 9.99213 416.206 11.2626 419.841 13.8035C423.47 16.3317 426.364 19.7746 428.517 24.1386C430.436 28.0261 431.494 32.2059 431.703 36.6652H435.103C434.882 31.5897 433.679 26.851 431.462 22.4552C429.005 17.5767 425.699 13.7272 421.538 10.9069C417.39 8.08646 412.919 6.67627 408.112 6.67627H372.153V36.6652H375.478V9.99213H375.491Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.118 69.9888C412.919 69.9888 417.39 68.5786 421.544 65.7583C425.705 62.9379 429.011 59.0884 431.468 54.2099C433.925 49.3314 435.154 44.04 435.154 38.342C435.154 37.7767 435.135 37.2177 435.11 36.665H431.709C431.734 37.2177 431.753 37.7767 431.753 38.342C431.753 43.4619 430.677 48.1943 428.523 52.5456C426.37 56.8905 423.482 60.3334 419.866 62.8616C416.25 65.4025 412.336 66.673 408.131 66.673H375.503V36.665H372.178V69.9888H408.137H408.118Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.542 36.665C438.567 37.224 438.58 37.783 438.58 38.342C438.58 43.0554 437.75 47.5845 436.104 51.9167C434.464 56.2553 432.279 59.9841 429.543 63.103C426.794 66.2156 423.546 68.6993 419.79 70.5542C416.047 72.4027 412.159 73.3238 408.125 73.3238H368.841V36.665H365.516V76.665H408.131C412.615 76.665 416.947 75.655 421.12 73.6287C425.293 71.6087 428.903 68.8836 431.949 65.4597C434.983 62.0359 437.421 57.9514 439.245 53.2062C441.088 48.4802 442.006 43.5191 442.006 38.342C442.006 37.7767 441.994 37.2177 441.975 36.665H438.548H438.542Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.538 53.3398H194.12V56.662H215.538C217.805 56.662 219.635 56.1347 221.022 55.0866C222.409 54.0385 223.106 52.3234 223.106 49.9477C223.106 45.7234 220.585 43.6145 215.544 43.6145H194.126V46.9494H215.544C216.918 46.9494 217.97 47.1463 218.704 47.5402C219.42 47.9467 219.781 48.7471 219.781 49.9477C219.781 52.2091 218.369 53.3398 215.544 53.3398H215.538Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.535 0V36.6651H285.859V5.42481L305.004 36.6651H308.912L286.505 0H282.535Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.751 0H353.427V36.6651H356.751V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.777 23.319H408.118C410.854 23.319 413.198 24.7801 415.148 27.7021C416.833 30.2176 417.789 33.2095 418.017 36.6587H421.443C421.177 32.3392 419.885 28.5787 417.548 25.3835C414.914 21.7945 411.773 19.9968 408.118 19.9968H385.453V36.6524H388.777V23.3127V23.319Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.118 56.6619C411.773 56.6619 414.914 54.8705 417.548 51.2942C420.183 47.7179 421.5 43.3984 421.5 38.342C421.5 37.7703 421.481 37.2177 421.443 36.665H418.017C418.055 37.2113 418.074 37.7703 418.074 38.342C418.074 42.4773 417.099 46.0092 415.148 48.9439C413.191 51.8786 410.848 53.3396 408.118 53.3396H388.777V36.665H385.453V56.6619H408.118Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.128 16.6682H408.125C411.133 16.6682 413.926 17.6337 416.497 19.5711C419.068 21.4959 421.114 24.1193 422.64 27.4606C423.932 30.3064 424.673 33.3745 424.857 36.665H428.289C428.093 32.7647 427.194 29.1376 425.591 25.7709C423.761 21.9278 421.291 18.8978 418.182 16.6682C415.072 14.4449 411.716 13.3333 408.125 13.3333H378.803V36.665H382.128V16.6682Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.465 50.6844V36.665H340.14V45.0881L343.465 50.6844Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.582 0H150.276V36.6651H153.582V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.821 25.9744V36.6652H299.152V31.5707L295.821 25.9744Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.945 0H143.62V36.6651H146.945V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.913 71.2402L135.761 36.6587H131.866L156.311 76.6587H160.244V36.665H156.919V71.2466L156.913 71.2402Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.945 50.6844V36.665H143.62V45.0881L146.945 50.6844Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.295 36.665H138.421L140.295 39.7649V36.665Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.67 0L124.089 36.6651H128.035L105.584 0H101.67Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.295 0H136.964V34.2639L138.421 36.6651H140.295V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8237 0L116.293 36.6651H120.169L97.6995 0H93.8237Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.336 0H109.46L131.866 36.6651H135.761L113.336 0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.582 61.7627V36.665H150.276V56.1092L153.582 61.7627Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.238 0H156.913V36.6651H160.238V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.127 0H263.802V36.6651H267.127V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.172 14.9023V36.6651H292.497V20.5558L289.172 14.9023Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.757 0H270.451V36.6651H273.757V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.834 0H250.509V36.6651H253.834V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.471 0H257.146V36.6651H260.471V0Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.786 34.0733C229.084 31.9771 229.73 29.5251 229.73 26.7174C229.73 23.1411 228.311 20.0095 225.48 17.3288C222.631 14.6609 219.318 13.3269 215.538 13.3269H182.302V36.665H185.614V16.6682H215.538C218.4 16.6682 220.927 17.6718 223.118 19.6855C225.322 21.6801 226.43 24.0304 226.43 26.7174C226.43 30.0396 225.373 32.625 223.251 34.4735C222.086 35.4898 220.775 36.2076 219.325 36.665H225.683C226.481 35.9027 227.184 35.0452 227.786 34.0733Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.538 23.319C216.76 23.319 217.773 23.624 218.584 24.2274C219.376 24.8372 219.775 25.663 219.775 26.7111C219.775 29.2647 218.362 30.5415 215.538 30.5415H194.12V33.8765H215.538C217.805 33.8765 219.635 33.3111 221.022 32.1868C222.409 31.0624 223.106 29.233 223.106 26.7048C223.106 24.7864 222.371 23.1857 220.896 21.9089C219.42 20.6321 217.64 19.9905 215.544 19.9905H188.946V36.646H192.27V23.3063H215.544L215.538 23.319Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.53 16.7446C231.617 13.632 229.053 11.1736 225.835 9.36962C222.625 7.57193 219.186 6.67627 215.532 6.67627H175.64V36.6652H178.965V9.99213H215.525C220.199 9.99213 224.29 11.6564 227.799 14.9786C231.301 18.2881 233.055 22.2011 233.055 26.7176C233.055 30.5162 231.934 33.8321 229.686 36.6652H233.169C235.297 33.6415 236.38 30.332 236.38 26.7176C236.38 23.1031 235.43 19.8444 233.524 16.7446H233.53Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.28 13.4032C236.772 9.28696 233.403 6.01556 229.166 3.60172C224.93 1.20057 220.389 0 215.538 0H169.015V36.6651H172.321V3.33492H215.538C219.812 3.33492 223.809 4.38939 227.526 6.49833C231.256 8.60727 234.22 11.4658 236.411 15.0675C238.615 18.6565 239.717 22.5377 239.717 26.7111C239.717 30.2303 238.767 33.5461 236.905 36.6587H240.502C242.187 33.7049 243.048 30.3954 243.048 26.7111C243.048 21.9597 241.794 17.5195 239.286 13.3969L239.28 13.4032Z",
    fill: "#373737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_8480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 442,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3a7f2378fc5b852615406ea2024f0006.svg";
export { ForwardRef as ReactComponent };